<template>
  <div>

    <div class="mb-5">
      <div class="page-title">
        สร้างข้อมูลโครงการหลัก
      </div>
    </div>

    <!--  Form  -->
    <div class="d-flex flex-column gap-16 mb-12">
      <divcard>
        <div class="card-part">
          <div class="txt-head black--text mb-3">
            ข้อมูลโครงการหลัก
          </div>

          <div>
            <div class="flex-center gap-16">
              <div class="flex xs3">
                <div class="mb-1 black--text">ปีงบประมาณ</div>
                <TextField
                    theme="3"
                    readonly
                    :value="form.fiscal_year"
                ></TextField>
              </div>

              <div class="flex xs9">
                <div class="mb-1 black--text">โครงการหลัก</div>
                <TextField
                    theme="3"
                    :value="form.name"
                    @onChange="setFormField('name', $event)"
                ></TextField>
              </div>
            </div>


            <div class="flex-center gap-16">
              <div class="flex xs3">
                <div class="mb-1 black--text">วันที่เปิดรับโครงการ</div>
                <DatePicker
                    :value="startDate"
                    @onInput="startDate = $event"
                ></DatePicker>
              </div>

              <div class="flex xs3">
                <div class="mb-1 black--text">เวลา</div>
                <TimePicker
                    :value="startTime"
                    @onInput="startTime = $event"
                ></TimePicker>
              </div>

              <div class="flex xs3">
                <div class="mb-1 black--text">ถึง</div>
                <DatePicker
                    :value="endDate"
                    @onInput="endDate = $event"
                ></DatePicker>
              </div>

              <div class="flex xs3">
                <div class="mb-1 black--text">เวลา</div>
                <TimePicker
                    :value="endTime"
                    @onInput="endTime = $event"
                ></TimePicker>
              </div>
            </div>

            <div class="flex-center gap-16">
              <div class="flex xs3">
                <div class="mb-1 black--text">วันที่พิจารณาโครงการ</div>
                <DatePicker
                    :value="form.consider_date"
                    @onInput="setFormField('consider_date', $event)"
                ></DatePicker>
              </div>

              <div class="flex xs9">
                <div class="mb-1 black--text">งบประมาณ</div>
                <TextField
                    theme="3"
                    input-type="decimal"
                    :value="form.budget"
                    @onChange="setFormField('budget', $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div class="d-flex align-center gap-12">
            <div class="mb-1 black--text">
              สถานะ
              <span class="theme-color-seven">*</span>
            </div>
            <SwitchInset
                :input-value="form.status"
                true-value="Active"
                false-value="Inactive"
                @onChange="setFormField('status', $event)"
            ></SwitchInset>
            <div>{{ form.status === 'Active' ? 'เปิดรับโครงการ' : 'ปิดรับโครงการ' }}</div>
          </div>
        </div>
      </divcard>

      <!--  Other Form  -->
      <FormIRTC v-if="irtcFormActive" :master-data="irtcMasterData"></FormIRTC>

      <FormCollaborative v-if="collaborativeFormActive" :master-data="collaborativeMasterData"></FormCollaborative>

      <FormSTI v-if="stiFormActive" :master-data="stiMasterData"></FormSTI>

      <FormServicePlatform v-if="servicePlatformFormActive" :master-data="servicePlatformMasterData"></FormServicePlatform>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="$router.push({ name: 'MainProject' })">ยกเลิก</Button>

      <div class="flex-center">
        <Button theme="4" min-width="120px" @onClick="save('draft')">บันทึกฉบับร่าง</Button>
        <Button min-width="120px" @onClick="save">บันทึก</Button>
      </div>
    </div>

  </div>
</template>

<script>
import Button from "../../components/input/Button"
import TextField from "../../components/input/TextField"
import TextArea from "../../components/input/TextArea"
import AutoBox from "../../components/input/AutoBox"
import SwitchInset from "../../components/input/SwitchInset"
import DatePicker from "../../components/input/DatePicker"
import TimePicker from "../../components/input/TimePicker"
import FormIRTC from "./MainProject/FormIRTC"
import FormCollaborative from "./MainProject/FormCollaborative"
import FormSTI from "./MainProject/FormSTI"
import FormServicePlatform from "./MainProject/FormServicePlatform"
import { eventBus } from "../../plugins/global-funcs"

export default {
  name: "MainProjectForm",
  components: {
    Button,
    TextField,
    TextArea,
    SwitchInset,
    DatePicker,
    TimePicker,
    AutoBox,
    FormIRTC,
    FormCollaborative,
    FormSTI,
    FormServicePlatform
  },
  data () {
    return {
      form: {
        status: 'Active'
      },
      irtcForm: {},
      collaborativeForm: {},
      stiForm: {},
      servicePlatformForm: {},
      irtcFormActive: false,
      collaborativeFormActive: false,
      stiFormActive: false,
      servicePlatformFormActive: false,
      irtcMasterData: {},
      collaborativeMasterData: {},
      stiMasterData: {},
      servicePlatformMasterData: {},
      startDate: undefined,
      endDate: undefined,
      startTime: undefined,
      endTime: undefined,
      testPayload: {}
    }
  },
  created () {
    this.getMasterData()
    this.retrieveForms()
  },
  methods: {
    async save (mode = 'save') {

      this.requestForm()

      let payload = {
        main_project: {
          fiscal_year: this.form.fiscal_year,
          name: this.form.name,
          start_date: this.startDate + ' ' + this.startTime,
          end_date: this.endDate + ' ' + this.endTime,
          consider_date: this.form.consider_date,
          budget: this.form.budget,
          status: this.form.status
        },
        plans: [
          {
            plan_master_id: 1,
            ...this.servicePlatformForm
          },
          {
            plan_master_id: 2,
            ...this.irtcForm
          },
          {
            plan_master_id: 3,
            ...this.stiForm
          },
          {
            plan_master_id: 4,
            ...this.collaborativeForm
          }
        ]
      }

      //check each plans has attachments or not
      if (payload.plans?.length > 0) {
        // console.log('has plans') //pass
        for (let i = 0; i < payload.plans.length; i++) {
          if (payload.plans[i].attachments?.length > 0) {
            // console.log('has attachments') //pass
            for (let j = 0; j < payload.plans[i].attachments.length; j++) {
              if (payload.plans[i].attachments[j] instanceof File) {
                console.log('has file at ' + i + ' ' + j)
                payload.plans[i].attachments[j] = await this.uploadFile(payload.plans[i].attachments[j])
              }
            }
          }
        }
      }

      this.testPayload = payload
      console.log('payload: ', payload)
      let res = await this.$apiFire('MainProject/storeMainProject', payload, true)
      console.log(res)

      if (res && res.message) {
        this.$store.commit('General/setModal', {
          title: 'เสร็จสิ้น!',
          theme: 'success',
          text: res.message,
          showCancel: false,
          action: () => this.$router.push({ name: 'MainProject' })
        })
      } else {
        this.$store.commit('General/setModal', {
          title: 'ข้อมูลไม่ครบถ้วน ?',
          theme: 'warning',
          text: typeof res === 'object' ? res.join(', ') : res,
          showCancel: false,
          buttonText: 'ตกลง'
        })
      }
    },
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    retrieveForms () {
      // IRTC form
      eventBus.$on('mainProjectFormIRTCSend', (form) => {
        this.irtcForm = form
        // keep in storage
        // this.$store.commit('CForm/setGeneralForm', this.irtcForm)
      })

      // Collaborative form
      eventBus.$on('mainProjectFormCollaborativeSend', (form) => {
        this.collaborativeForm = form
        // keep in storage
        // this.$store.commit('CForm/setProjectForm', this.collaborativeForm)
      })

      // STI form
      eventBus.$on('mainProjectFormSTISend', (form) => {
        this.stiForm = form
        // keep in storage
        // this.$store.commit('CForm/setPlanForm', this.stiForm)
      })

      // Service Platform form
      eventBus.$on('mainProjectFormServicePlatformSend', (form) => {
        this.servicePlatformForm = form
        // keep in storage
        // this.$store.commit('CForm/setOOIForm', this.servicePlatformForm)
      })

    },
    requestForm () {
      eventBus.$emit('mainProjectFormIRTC')
      eventBus.$emit('mainProjectFormCollaborative')
      eventBus.$emit('mainProjectFormSTI')
      eventBus.$emit('mainProjectFormServicePlatform')
    },
    async getMasterData () {
      let res = await this.$apiFire('MainProject/getMasterMainProject')
      console.log(res)
      if (res) {
        this.form.fiscal_year = res.fiscal_year
        for (const x of res.plan_master) {
          switch (x.id) {
            case 1:
              if (x.is_active) {
                this.servicePlatformMasterData = x
                this.servicePlatformFormActive = true
              }
              break
            case 2:
              if (x.is_active) {
                this.irtcMasterData = x
                this.irtcFormActive = true
              }
              break
            case 3:
              if (x.is_active) {
                this.stiMasterData = x
                this.stiFormActive = true
              }
              break
            case 4:
              if (x.is_active) {
                this.collaborativeMasterData = x
                this.collaborativeFormActive = true
              }
              break
          }
        }
      }
    },
    async uploadFile(file){
      let formData = new FormData();
      formData.append('files[]', file);
      let payload = {
        files : formData
      }
      let res = await this.$apiFire('Attachment/uploadFile', formData)
      console.log('res@uploadFile', res)
      if (res.length > 0) {
        console.log('file uploaded', res[0])
        return res[0]
      }
    },
  }
}
</script>

<style scoped lang="scss">


</style>